import React from "react"

// Views
import AppPanel from "@views/AppPanel"

// Components
import Headline from "@components/Headline"

// Markups
import CodeMD from "@views/code.md"

function Code() {
    return (
        <AppPanel>
            <Headline>SKIP/Code</Headline>
            <CodeMD />
        </AppPanel>
    )
}

export default Code
